import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__unaryMinus_impl_x5smq036mvwk2sni6rt as MonetaryValue__unaryMinus_impl_x5smq0,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  ChangeRequestItem25pmay5za3qvv as ChangeRequestItem,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  ItemChangeInterface3dt2mjp367emm as ItemChangeInterface,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  LineItemFromChangeRequest29s1k7nucgyuu as LineItemFromChangeRequest,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_displayColor1gavqb36ugd6h as get_displayColor,
  DirectlyDisplayableStatebtdfi3611j0b as DirectlyDisplayableState,
} from '../payApps/data.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  single3ds7xj9roxi5z as single,
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_getInstance24j3x2uirrx0g as Companion_getInstance,
  UnreadHandler2tbwn0on02mwe as UnreadHandler,
} from '../../../../../sdk/ReadByModelCache.mjs';
import { isUnread2wfj6ps7oiv9h as isUnread } from '../../../../../extensions/HasReadBy.ext.mjs';
import {
  ItemChangee3c665suy3yz as ItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { invokeAllSafe19fa1obs302ra as invokeAllSafe } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ChangeRequestItemWrapperClass;
function ChangeRequestItemWrapper() {
  if (ChangeRequestItemWrapperClass === VOID) {
    class $ {
      constructor(wrapped, name, originalPrice) {
        this.ogp_1 = wrapped;
        this.pgp_1 = name;
        this.qgp_1 = originalPrice;
      }
      e26() {
        return this.ogp_1.y94();
      }
      th7() {
        var tmp0_elvis_lhs = this.w94();
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = Companion_instance.r91(0n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return MonetaryValue__plus_impl_c1ylt(this.qgp_1, tmp);
      }
      w94() {
        return get_cancelled(this.ogp_1) ? MonetaryValue__unaryMinus_impl_x5smq0(this.qgp_1) : this.ogp_1.w94();
      }
      toString() {
        return 'ChangeRequestItemWrapper(wrapped=' + toString(this.ogp_1) + ', name=' + this.pgp_1 + ', originalPrice=' + MonetaryValue__toString_impl_xslc77(this.qgp_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.ogp_1);
        result = imul(result, 31) + getStringHashCode(this.pgp_1) | 0;
        result = imul(result, 31) + MonetaryValue__hashCode_impl_fhcsz2(this.qgp_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequestItemWrapper()))
          return false;
        if (!equals(this.ogp_1, other.ogp_1))
          return false;
        if (!(this.pgp_1 === other.pgp_1))
          return false;
        if (!(this.qgp_1 === other.qgp_1))
          return false;
        return true;
      }
      t94() {
        return this.ogp_1.t94();
      }
      b95() {
        return this.ogp_1.b95();
      }
      s94() {
        return this.ogp_1.s94();
      }
      y94() {
        return this.ogp_1.y94();
      }
      u94() {
        return this.ogp_1.u94();
      }
      z94() {
        return this.ogp_1.z94();
      }
      a95() {
        return this.ogp_1.a95();
      }
      j95() {
        return this.ogp_1.j95();
      }
      v91() {
        return this.ogp_1.v91();
      }
      f40() {
        return this.ogp_1.f40();
      }
    }
    initMetadataForClass($, 'ChangeRequestItemWrapper', VOID, VOID, [ChangeRequestItem()]);
    ChangeRequestItemWrapperClass = $;
  }
  return ChangeRequestItemWrapperClass;
}
var ChangeStatus_Accepted_instance;
var ChangeStatus_Rejected_instance;
var ChangeStatus_Voided_instance;
var ChangeStatus_PendingApproval_instance;
var ChangeStatus_entriesInitialized;
function ChangeStatus_initEntries() {
  if (ChangeStatus_entriesInitialized)
    return Unit_instance;
  ChangeStatus_entriesInitialized = true;
  ChangeStatus_Accepted_instance = ChangeStatus().yh7('Accepted', 0, 'Approved', AppColors_getInstance().ffz_1.zg9_1);
  ChangeStatus_Rejected_instance = ChangeStatus().yh7('Rejected', 1, 'Rejected', AppColors_getInstance().jfz_1.zg9_1);
  ChangeStatus_Voided_instance = ChangeStatus().yh7('Voided', 2, 'Voided', AppColors_getInstance().hfz_1.zg9_1);
  ChangeStatus_PendingApproval_instance = ChangeStatus().yh7('PendingApproval', 3, 'Pending Approval', AppColors_getInstance().hfz_1.zg9_1);
}
var ChangeStatusClass;
function ChangeStatus() {
  if (ChangeStatusClass === VOID) {
    class $ extends Enum() {
      static yh7(name, ordinal, displayName, color) {
        var $this = this.c4(name, ordinal);
        $this.wh7_1 = displayName;
        $this.xh7_1 = color;
        return $this;
      }
      e90() {
        return this.wh7_1;
      }
      hg0() {
        return this.xh7_1;
      }
      g90() {
        return 0;
      }
    }
    protoOf($).f90 = get_displayColor;
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ChangeStatus', VOID, VOID, [DirectlyDisplayableState(), Enum()]);
    ChangeStatusClass = $;
  }
  return ChangeStatusClass;
}
function get_status(_this__u8e3s4) {
  return !(_this__u8e3s4.a95() == null) ? ChangeStatus_Rejected_getInstance() : !(_this__u8e3s4.z94() == null) ? ChangeStatus_Accepted_getInstance() : !(_this__u8e3s4.j95() == null) ? ChangeStatus_Voided_getInstance() : ChangeStatus_PendingApproval_getInstance();
}
function status(_this__u8e3s4, items) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = get_status(item);
    destination.v(tmp$ret$0);
  }
  // Inline function 'kotlin.let' call
  var itemStates = toSet(destination);
  var tmp;
  if (_this__u8e3s4.t57_1 == null || itemStates.i1()) {
    tmp = Status_Draft_getInstance();
  } else {
    if (itemStates.p1() === 1) {
      var tmp_0;
      switch (single(itemStates).b4_1) {
        case 0:
          tmp_0 = Status_Accepted_getInstance();
          break;
        case 1:
          tmp_0 = Status_Rejected_getInstance();
          break;
        case 2:
          tmp_0 = Status_Voided_getInstance();
          break;
        case 3:
          tmp_0 = Status_PendingApproval_getInstance();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(itemStates, Collection())) {
          tmp_1 = itemStates.i1();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = itemStates.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          if (element.equals(ChangeStatus_PendingApproval_getInstance())) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3) {
        tmp = Status_InReview_getInstance();
      } else {
        var tmp$ret$5;
        $l$block_2: {
          // Inline function 'kotlin.collections.none' call
          var tmp_2;
          if (isInterface(itemStates, Collection())) {
            tmp_2 = itemStates.i1();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$5 = true;
            break $l$block_2;
          }
          var _iterator__ex2g4s_1 = itemStates.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_0 = _iterator__ex2g4s_1.o1();
            if (element_0.equals(ChangeStatus_PendingApproval_getInstance())) {
              tmp$ret$5 = false;
              break $l$block_2;
            }
          }
          tmp$ret$5 = true;
        }
        if (tmp$ret$5) {
          tmp = Status_PartiallyAccepted_getInstance();
        } else {
          tmp = Status_Draft_getInstance();
        }
      }
    }
  }
  return tmp;
}
var Status_Draft_instance;
var Status_PendingApproval_instance;
var Status_InReview_instance;
var Status_PartiallyAccepted_instance;
var Status_Accepted_instance;
var Status_Rejected_instance;
var Status_Voided_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_Draft_instance = Status().dh8('Draft', 0, 'Draft', AppColors_getInstance().hfz_1.zg9_1);
  Status_PendingApproval_instance = Status().dh8('PendingApproval', 1, 'Submitted', AppColors_getInstance().efz_1.zg9_1);
  Status_InReview_instance = Status().dh8('InReview', 2, 'Open - Partial', AppColors_getInstance().kfz_1.zg9_1);
  Status_PartiallyAccepted_instance = Status().dh8('PartiallyAccepted', 3, 'Closed - Partial', AppColors_getInstance().kfz_1.zg9_1);
  Status_Accepted_instance = Status().dh8('Accepted', 4, 'Approved', AppColors_getInstance().ffz_1.zg9_1);
  Status_Rejected_instance = Status().dh8('Rejected', 5, 'Rejected', AppColors_getInstance().jfz_1.zg9_1);
  Status_Voided_instance = Status().dh8('Voided', 6, 'Voided', AppColors_getInstance().hfz_1.zg9_1);
}
var StatusClass;
function Status() {
  if (StatusClass === VOID) {
    class $ extends Enum() {
      static dh8(name, ordinal, displayName, color) {
        var $this = this.c4(name, ordinal);
        $this.bh8_1 = displayName;
        $this.ch8_1 = color;
        return $this;
      }
      e90() {
        return this.bh8_1;
      }
      hg0() {
        return this.ch8_1;
      }
      g90() {
        return 0;
      }
    }
    protoOf($).f90 = get_displayColor;
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'Status', VOID, VOID, [DirectlyDisplayableState(), Enum()]);
    StatusClass = $;
  }
  return StatusClass;
}
function Status_Draft_getInstance() {
  Status_initEntries();
  return Status_Draft_instance;
}
function Status_PendingApproval_getInstance() {
  Status_initEntries();
  return Status_PendingApproval_instance;
}
function Status_InReview_getInstance() {
  Status_initEntries();
  return Status_InReview_instance;
}
function Status_PartiallyAccepted_getInstance() {
  Status_initEntries();
  return Status_PartiallyAccepted_instance;
}
function Status_Accepted_getInstance() {
  Status_initEntries();
  return Status_Accepted_instance;
}
function Status_Rejected_getInstance() {
  Status_initEntries();
  return Status_Rejected_instance;
}
function Status_Voided_getInstance() {
  Status_initEntries();
  return Status_Voided_instance;
}
var ChangeRequestDataClass;
function ChangeRequestData() {
  if (ChangeRequestDataClass === VOID) {
    class $ {
      constructor(changeRequest, changes) {
        this.eh8_1 = changeRequest;
        this.fh8_1 = changes;
        this.gh8_1 = status(this.eh8_1, this.fh8_1);
        this.hh8_1 = sortTypes(this.fh8_1);
        var tmp = this;
        // Inline function 'kotlin.collections.filterNot' call
        var tmp0 = this.hh8_1.kh8_1;
        // Inline function 'kotlin.collections.filterNotTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!element.g72_1) {
            destination.v(element);
          }
        }
        tmp.ih8_1 = destination;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = this.hh8_1.kh8_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.g72_1) {
            destination_0.v(element_0);
          }
        }
        tmp_0.jh8_1 = destination_0;
      }
      oh8() {
        return this.hh8_1.lh8_1;
      }
      toString() {
        return 'ChangeRequestData(changeRequest=' + this.eh8_1.toString() + ', changes=' + toString(this.fh8_1) + ')';
      }
      hashCode() {
        var result = this.eh8_1.hashCode();
        result = imul(result, 31) + hashCode(this.fh8_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ChangeRequestData()))
          return false;
        if (!this.eh8_1.equals(other.eh8_1))
          return false;
        if (!equals(this.fh8_1, other.fh8_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ChangeRequestData');
    ChangeRequestDataClass = $;
  }
  return ChangeRequestDataClass;
}
function get_cancelled(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
    tmp = get_cancelled(_this__u8e3s4.ogp_1);
  } else {
    if (isInterface(_this__u8e3s4, LineItemInterface())) {
      tmp = false;
    } else {
      if (isInterface(_this__u8e3s4, ItemChangeInterface())) {
        tmp = _this__u8e3s4.x94();
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem type');
      }
    }
  }
  return tmp;
}
var SortedChangeItemsClass;
function SortedChangeItems() {
  if (SortedChangeItemsClass === VOID) {
    class $ {
      constructor(pendingChanges, pendingItems, itemChanges, lineItems) {
        this.kh8_1 = pendingChanges;
        this.lh8_1 = pendingItems;
        this.mh8_1 = itemChanges;
        this.nh8_1 = lineItems;
      }
      toString() {
        return 'SortedChangeItems(pendingChanges=' + toString(this.kh8_1) + ', pendingItems=' + toString(this.lh8_1) + ', itemChanges=' + toString(this.mh8_1) + ', lineItems=' + toString(this.nh8_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.kh8_1);
        result = imul(result, 31) + hashCode(this.lh8_1) | 0;
        result = imul(result, 31) + hashCode(this.mh8_1) | 0;
        result = imul(result, 31) + hashCode(this.nh8_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SortedChangeItems()))
          return false;
        if (!equals(this.kh8_1, other.kh8_1))
          return false;
        if (!equals(this.lh8_1, other.lh8_1))
          return false;
        if (!equals(this.mh8_1, other.mh8_1))
          return false;
        if (!equals(this.nh8_1, other.nh8_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SortedChangeItems');
    SortedChangeItemsClass = $;
  }
  return SortedChangeItemsClass;
}
function sortTypes(_this__u8e3s4) {
  var pendingChanges = ArrayList().w();
  var pendingItems = ArrayList().w();
  var changes = ArrayList().w();
  var lines = ArrayList().w();
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    sortTypes$sort(pendingChanges, pendingItems, changes, lines, element);
  }
  return new (SortedChangeItems())(pendingChanges, pendingItems, changes, lines);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.qh8_1.nh8_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.da0_1;
    destination.v(tmp$ret$0);
  }
  var tmp = $this.ph8_1.ofv_1.ffu_1.vf9(destination, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = tmp;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = this_1.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = element.e6k_1;
    destination_0.s3(tmp$ret$3, element);
  }
  var updates = destination_0;
  $this.ph8_1.ofv_1.aft(updates);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.sh8_1.nh8_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.da0_1;
    destination.v(tmp$ret$0);
  }
  var tmp = $this.rh8_1.ofv_1.ffu_1.vf9(destination, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = tmp;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = this_1.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = element.e6k_1;
    destination_0.s3(tmp$ret$3, element);
  }
  var updates = destination_0;
  return () => {
    $this.rh8_1.ofv_1.aft(updates);
    return Unit_instance;
  };
}
function reduce($this, _this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.p1()) {
    case 0:
      tmp = null;
      break;
    case 1:
      tmp = first(_this__u8e3s4);
      break;
    default:
      tmp = invokeAllSafe$ref(toList(_this__u8e3s4));
      break;
  }
  return tmp;
}
function *_generator_markFeedbackAsReadDelayUpdate__j8lkbm($this, items, $completion) {
  var sorted = sortTypes(items);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.vfv_1.wft(sorted.kh8_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = session.ufv_1.wft(sorted.lh8_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return reduce($this, listOfNotNull([tmp_0, tmp_1]));
}
function toHandler($this, _this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.i1()) {
    tmp = Companion_getInstance().fft_1;
  } else {
    // Inline function 'kotlin.collections.reduce' call
    var iterator = _this__u8e3s4.m1();
    if (!iterator.n1())
      throw UnsupportedOperationException().i5("Empty collection can't be reduced.");
    var accumulator = iterator.o1();
    while (iterator.n1()) {
      var tmp0 = accumulator;
      var handler = iterator.o1();
      accumulator = tmp0.ufw(handler);
    }
    tmp = accumulator;
  }
  return tmp;
}
function *_generator_handle__eiwcio($this, items, $completion) {
  var sorted = sortTypes(items);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.kh8_1.i1()) {
    tmp_0 = session.vfv_1.if9(VOID, ($this$handle, it) => sorted.kh8_1);
  } else {
    tmp_0 = null;
  }
  var tmp_1 = tmp_0;
  var tmp_2;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.lh8_1.i1()) {
    tmp_2 = session.ufv_1.if9(VOID, ($this$handle, it) => sorted.lh8_1);
  } else {
    tmp_2 = null;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.mh8_1.i1()) {
    tmp_4 = session.pfv_1.if9(VOID, ($this$handle, it) => sorted.mh8_1);
  } else {
    tmp_4 = null;
  }
  var tmp_5 = tmp_4;
  var tmp_6;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.nh8_1.i1()) {
    var tmp_7 = ($this$UnreadHandler, it) => isUnread(sorted.nh8_1, session.gfv_1);
    tmp_6 = new (UnreadHandler())('LineItemFromChangeRequest', tmp_7, ChangeItemReadReceipts$handle$slambda_0(session, sorted));
  } else {
    tmp_6 = null;
  }
  return toHandler($this, listOfNotNull([tmp_1, tmp_3, tmp_5, tmp_6]));
}
function *_generator_handleDelayUpdate__xu5ikw($this, items, $completion) {
  var sorted = sortTypes(items);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.kh8_1.i1()) {
    tmp_0 = session.vfv_1.jft(VOID, ($this$handleDelayUpdate, it) => sorted.kh8_1);
  } else {
    tmp_0 = null;
  }
  var tmp_1 = tmp_0;
  var tmp_2;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.lh8_1.i1()) {
    tmp_2 = session.ufv_1.jft(VOID, ($this$handleDelayUpdate, it) => sorted.lh8_1);
  } else {
    tmp_2 = null;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.mh8_1.i1()) {
    tmp_4 = session.pfv_1.jft(VOID, ($this$handleDelayUpdate, it) => sorted.mh8_1);
  } else {
    tmp_4 = null;
  }
  var tmp_5 = tmp_4;
  var tmp_6;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.nh8_1.i1()) {
    var tmp_7 = ($this$UnreadHandler, it) => isUnread(sorted.nh8_1, session.gfv_1);
    tmp_6 = new (UnreadHandler())('LineItemFromChangeRequest', tmp_7, VOID, ChangeItemReadReceipts$handleDelayUpdate$slambda_0(session, sorted));
  } else {
    tmp_6 = null;
  }
  return toHandler($this, listOfNotNull([tmp_1, tmp_3, tmp_5, tmp_6]));
}
function *_generator_handleFeedback__fuy15n($this, items, $completion) {
  var sorted = sortTypes(items);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.kh8_1.i1()) {
    tmp_0 = session.vfv_1.afu(VOID, ($this$handleFeedback, it) => sorted.kh8_1);
  } else {
    tmp_0 = null;
  }
  var tmp_1 = tmp_0;
  var tmp_2;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!sorted.lh8_1.i1()) {
    tmp_2 = session.ufv_1.afu(VOID, ($this$handleFeedback, it) => sorted.lh8_1);
  } else {
    tmp_2 = null;
  }
  return toHandler($this, listOfNotNull([tmp_1, tmp_2]));
}
function *_generator_markAsReadDelayUpdate__jx65oj($this, item, $completion) {
  var tmp;
  if (item instanceof ChangeRequestItemWrapper()) {
    var tmp_0 = $this.th8(item.ogp_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    if (item instanceof PendingItemChange()) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = get_session();
      var tmp_1 = await_0(this_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp_2 = tmp_1.vfv_1.gf9(listOf(item), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp = tmp_2;
    } else {
      if (item instanceof PendingLineItem()) {
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_1 = get_session();
        var tmp_3 = await_0(this_1, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp_4 = tmp_3.ufv_1.gf9(listOf(item), $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp = tmp_4;
      } else {
        if (item instanceof ItemChange()) {
          // Inline function 'com.lightningkite.reactive.context.invoke' call
          var this_2 = get_session();
          var tmp_5 = await_0(this_2, $completion);
          if (tmp_5 === get_COROUTINE_SUSPENDED())
            tmp_5 = yield tmp_5;
          var tmp_6 = tmp_5.pfv_1.gf9(listOf(item), $completion);
          if (tmp_6 === get_COROUTINE_SUSPENDED())
            tmp_6 = yield tmp_6;
          tmp = tmp_6;
        } else {
          if (item instanceof LineItemFromChangeRequest()) {
            // Inline function 'com.lightningkite.reactive.context.invoke' call
            var this_3 = get_session();
            var tmp_7 = await_0(this_3, $completion);
            if (tmp_7 === get_COROUTINE_SUSPENDED())
              tmp_7 = yield tmp_7;
            var session = tmp_7;
            var tmp_8 = session.ofv_1.ffu_1.vf9(listOf(item.da0_1), $completion);
            if (tmp_8 === get_COROUTINE_SUSPENDED())
              tmp_8 = yield tmp_8;
            var update = firstOrNull(tmp_8);
            tmp = () => {
              var tmp = (it) => {
                var tmp0_safe_receiver = update;
                return it.e6k_1.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6k_1);
              };
              session.ofv_1.eeo(tmp, (it) => update);
              return Unit_instance;
            };
          } else {
            tmp = null;
          }
        }
      }
    }
  }
  return tmp;
}
function *_generator_markAsRead__9da6tv($this, item, $completion) {
  var tmp = $this.th8(item, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
}
function invokeAllSafe$ref(p0) {
  var l = () => {
    var tmp0 = p0;
    invokeAllSafe(tmp0);
    return Unit_instance;
  };
  l.callableName = 'invokeAllSafe';
  return l;
}
var ChangeItemReadReceipts$handle$slambdaClass;
function ChangeItemReadReceipts$handle$slambda() {
  if (ChangeItemReadReceipts$handle$slambdaClass === VOID) {
    class $ {
      constructor($session, $sorted) {
        this.ph8_1 = $session;
        this.qh8_1 = $sorted;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeItemReadReceipts$handle$slambdaClass = $;
  }
  return ChangeItemReadReceipts$handle$slambdaClass;
}
function ChangeItemReadReceipts$handle$slambda_0($session, $sorted) {
  var i = new (ChangeItemReadReceipts$handle$slambda())($session, $sorted);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeItemReadReceipts$handleDelayUpdate$slambdaClass;
function ChangeItemReadReceipts$handleDelayUpdate$slambda() {
  if (ChangeItemReadReceipts$handleDelayUpdate$slambdaClass === VOID) {
    class $ {
      constructor($session, $sorted) {
        this.rh8_1 = $session;
        this.sh8_1 = $sorted;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeItemReadReceipts$handleDelayUpdate$slambdaClass = $;
  }
  return ChangeItemReadReceipts$handleDelayUpdate$slambdaClass;
}
function ChangeItemReadReceipts$handleDelayUpdate$slambda_0($session, $sorted) {
  var i = new (ChangeItemReadReceipts$handleDelayUpdate$slambda())($session, $sorted);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeItemReadReceiptsClass;
function ChangeItemReadReceipts() {
  if (ChangeItemReadReceiptsClass === VOID) {
    class $ {
      uh8(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markFeedbackAsReadDelayUpdate__j8lkbm.bind(VOID, this, items), $completion);
      }
      vh8(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_handle__eiwcio.bind(VOID, this, items), $completion);
      }
      wh8(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_handleDelayUpdate__xu5ikw.bind(VOID, this, items), $completion);
      }
      xh8(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_handleFeedback__fuy15n.bind(VOID, this, items), $completion);
      }
      th8(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsReadDelayUpdate__jx65oj.bind(VOID, this, item), $completion);
      }
      yh8(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsRead__9da6tv.bind(VOID, this, item), $completion);
      }
    }
    initMetadataForObject($, 'ChangeItemReadReceipts', VOID, VOID, VOID, [1]);
    ChangeItemReadReceiptsClass = $;
  }
  return ChangeItemReadReceiptsClass;
}
var ChangeItemReadReceipts_instance;
function ChangeItemReadReceipts_getInstance() {
  return ChangeItemReadReceipts_instance;
}
function sortTypes$sort(pendingChanges, pendingItems, changes, lines, item) {
  if (item instanceof ChangeRequestItemWrapper()) {
    sortTypes$sort(pendingChanges, pendingItems, changes, lines, item.ogp_1);
  } else {
    if (item instanceof PendingItemChange()) {
      pendingChanges.v(item);
    } else {
      if (item instanceof PendingLineItem()) {
        pendingItems.v(item);
      } else {
        if (item instanceof ItemChange()) {
          changes.v(item);
        } else {
          if (item instanceof LineItemFromChangeRequest()) {
            lines.v(item);
          }
        }
      }
    }
  }
}
function ChangeStatus_Accepted_getInstance() {
  ChangeStatus_initEntries();
  return ChangeStatus_Accepted_instance;
}
function ChangeStatus_Rejected_getInstance() {
  ChangeStatus_initEntries();
  return ChangeStatus_Rejected_instance;
}
function ChangeStatus_Voided_getInstance() {
  ChangeStatus_initEntries();
  return ChangeStatus_Voided_instance;
}
function ChangeStatus_PendingApproval_getInstance() {
  ChangeStatus_initEntries();
  return ChangeStatus_PendingApproval_instance;
}
//region block: init
ChangeItemReadReceipts_instance = new (ChangeItemReadReceipts())();
//endregion
//region block: exports
export {
  ChangeRequestData as ChangeRequestData3ach2rh1k570,
  ChangeRequestItemWrapper as ChangeRequestItemWrapperlr7b47p0t9ty,
  get_cancelled as get_cancelled2lvhzg5ousqkd,
  get_status as get_status1d77371nrw24k,
  status as status2ejx1l1gl01uw,
  Status_Accepted_getInstance as Status_Accepted_getInstance2m2t31poyo55g,
  Status_Draft_getInstance as Status_Draft_getInstance6tlwzpe7uax3,
  Status_InReview_getInstance as Status_InReview_getInstance139tuomqphme,
  Status_PartiallyAccepted_getInstance as Status_PartiallyAccepted_getInstancetm1ylzstkb4p,
  Status_PendingApproval_getInstance as Status_PendingApproval_getInstance15f8iecb9d1o9,
  Status_Rejected_getInstance as Status_Rejected_getInstance185k56u04ge1z,
  ChangeStatus_Accepted_getInstance as ChangeStatus_Accepted_getInstance2k8febn59t1nq,
  ChangeStatus_PendingApproval_getInstance as ChangeStatus_PendingApproval_getInstance38hxy51hg7vly,
  ChangeStatus_Rejected_getInstance as ChangeStatus_Rejected_getInstance5u2zdbak9nj5,
  ChangeItemReadReceipts_instance as ChangeItemReadReceipts_instance2jo5uerda8tke,
};
//endregion

//# sourceMappingURL=data.mjs.map
